import { PageController } from '@client/components/_core/layout/PageController';
import { SupplierEdit } from '@client/components/suppliers/SupplierEdit';
import { useNavigate } from '@client/hooks/navigation/useNavigate';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/console/$orgId/claims/details/$id/financials/compensations/add/suppliers/add')({
    staticData: {
        presentation: 'overlay',
        metadata: {
            title: 'New supplier',
        },
    },
    component: RouteComponent,
});

function RouteComponent() {
    const navigate = useNavigate();

    return (
        <PageController route={Route}>
            <SupplierEdit onSuccess={() => navigate({ moveInMatches: -1 })} />
        </PageController>
    );
}
